<template>
    <div class="mobile-navbar d-md-none">
        <nav class="mobile-nav">
            <router-link class="mobile-nav-item" to="/cabinet">
                <i class="bi bi-house"></i>
                <span>{{ $t('mobileNavbar.cabinet') }}</span>
            </router-link>
            <router-link class="mobile-nav-item" :to="role === 'admin' ? '/plans' : '/plans-table'">
                <i class="bi bi-piggy-bank"></i>
                <span>{{ $t('mobileNavbar.plans') }}</span>
            </router-link>
            <router-link v-if="role === 'admin'" class="mobile-nav-item" to="/modules">
                <i class="bi bi-diagram-2"></i>
                <span>{{ $t('mobileNavbar.modules') }}</span>
            </router-link>
            <router-link v-if="role === 'admin'" class="mobile-nav-item" to="/users">
                <i class="bi bi-people"></i>
                <span>{{ $t('mobileNavbar.users') }}</span>
            </router-link>
            <div class="mobile-nav-item dropup lang-switcher">
                <a href="#" class="mobile-nav-item p-0" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-translate"></i>
                    <span>{{ currentLocaleLabel }}</span>
                </a>
                <ul class="dropdown-menu">
                    <li v-for="loc in locales" :key="loc.code">
                        <a class="dropdown-item" href="#" :class="{ active: locale === loc.code }" @click.prevent="changeLocale(loc.code)">{{ loc.label }}</a>
                    </li>
                </ul>
            </div>
            <a class="mobile-nav-item cabinet-back" href="https://cabinet.superqr.com/cabinet">
                <i class="bi bi-arrow-left-circle"></i>
                <span>{{ $t('mobileNavbar.cabinet') }}</span>
            </a>
            <a class="mobile-nav-item" href="#" @click.prevent="logout">
                <i class="bi bi-box-arrow-left"></i>
                <span>{{ $t('mobileNavbar.logout') }}</span>
            </a>
        </nav>
    </div>
</template>

<script>
import i18n, { setLocale } from '../i18n'

export default {
    data: () => ({
        role: '',
        locales: [
            { code: 'ru', label: 'RU' },
            { code: 'kz', label: 'KZ' },
            { code: 'en', label: 'EN' },
            { code: 'zh', label: '中' }
        ]
    }),
    computed: {
        locale() {
            return i18n.global.locale.value
        },
        currentLocaleLabel() {
            return this.locales.find(l => l.code === this.locale)?.label ?? 'RU'
        }
    },
    async mounted() {
        let user = await this.$api.getUser()
        if(user.result === 'SUCCESS') {
            this.role = user.data.role
        }
    },
    methods: {
        changeLocale(code) {
            setLocale(code)
        },
        async logout() {
            let response = await this.$api.logout()
            if(response.result === 'SUCCESS') {
                this.$router.push('/login')
            }
        }
    }
}
</script>

<style scoped>
.mobile-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: var(--bg-card);
    border-top: 1px solid var(--border-color);
    padding: 0.5em 0 env(safe-area-inset-bottom, 0.5em);
    z-index: 20;
}

.mobile-nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.15em;
    text-decoration: none;
    color: var(--text-muted);
    font-size: 10px;
    font-weight: 500;
    padding: 0.4em 0.75em;
    border-radius: 8px;
    transition: var(--default-transition);
}

.mobile-nav-item .bi {
    font-size: 20px;
}

.mobile-nav-item.router-link-active {
    color: var(--primary-color);
}

.mobile-nav-item.cabinet-back {
    color: var(--primary-color);
}

.lang-switcher {
    padding: 0;
}

.lang-switcher > a {
    background: none;
    border: 0;
}

.lang-switcher .dropdown-menu {
    min-width: auto;
}
</style>
